import { Outlet } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
  return (
    <div className="relative overflow-hidden w-full h-full pb-20 2xl:pb-0 max-w-[2800px] mx-auto">
      <Header />
      <Outlet />
    </div>
  );
}
